const config = {
  BASE_URL: "https://backend.bookndrive.in",
  PUBLIC_URL: "https://backend.bookndrive.in/public/",

  // BASE_URL: "http://127.0.0.1:8000",
  // PUBLIC_URL: "http://127.0.0.1:8000/",
};

export default config;